import { SessionStorageAdapter } from '@pp/toolkit';

import { Logger } from '../../logger/Logger';

export const SessionStorage = new SessionStorageAdapter();

SessionStorage.addEventListener('error', (key, operation) => {
  Logger.logFailure('sessionStorage', {
    place: operation,
    additional: key,
  });
});
